import * as Actions from '../actionsgazeta';

const initialState = [];

const pesquisa = function (state = initialState, action) {
    switch (action.type) {
        case Actions.SET_PESQUISA_DATA:
            {
                return action.payload

            }
        case Actions.CLEAR_PESQUISA_DATA:
            {
                return state;
            }
        default:
            {
                return state
            }
    }
};

export default pesquisa;
